import AxiosProvider from '@/app/utils/api/axios-provider';
import { AxiosResponse } from 'axios';
import { User } from '@/app/shared/types/models/user.interface';

export interface PaginationParams {
  page?: number;
  size?: number;
  sortBy?: string;
  sortDir?: 'asc' | 'desc';
}

export default {
  getUsers(params?: PaginationParams): Promise<AxiosResponse> {
    return AxiosProvider.adminApiClient.get('/users', { params });
  },

  getUserById(id: number | string): Promise<AxiosResponse> {
    return AxiosProvider.adminApiClient.get(`/users/${id}`);
  },

  createUser(user: User): Promise<AxiosResponse> {
    return AxiosProvider.adminApiClient.post('/users', user);
  },

  updateUser(id: number | string, user: User): Promise<AxiosResponse> {
    return AxiosProvider.adminApiClient.patch(`/users/${id}`, user);
  },

  deleteUser(id: number | string): Promise<AxiosResponse> {
    return AxiosProvider.adminApiClient.delete(`/users/${id}`);
  },
};
